/**
 * @Author:
 * @Description:
 * @DateTime: Created in 13:50 2020/10/13
 */

 import * as Vue from 'vue-tsx-support';
 import { Component, Prop } from 'vue-property-decorator';
 import 'vue-tsx-support/enable-check';
 import DictSelect, { DictSelectPropsI } from '../SelectCustom/dictSelect';
 import EnumSelect, { EnumSelectPropsI } from '../SelectCustom/enumSelect';
 import Button from '../../types/iview/Button';
 import BooleanSelect, { BooleanSelectPropsI } from '../SelectCustom/booleanSelect';
 import { DateTimeUtil, GetMillisecondType } from '../../util/dateTimeUtil';
 import { IViewDate } from '../../types/base';
 import DatePicker, { DatePickerProps } from '../../types/iview/DatePicker';
 import { Constructor } from 'vue-tsx-support';
 import CommonSelect, { CommonSelectVOI } from '../SelectCustom/commonSelect';
 import { CommonUtil } from 'src/util/commonUtil';
 import Input from 'src/types/iview/Input';
 export namespace QueryFormVOI {
     export interface PropsI {
         labelWidth?: number;
         dataSource: QueryFormVOI.DateItemType[];
         showClear?: boolean;
     }
     type DateItemTypeI<T, T_PROPS> = {
         component: Constructor<T>|string;
         props: T_PROPS;
         labelWidth?: number;
         width?: number;
         field: string;
         label: string;
         realField?: string[];
         // 时间类型 用于获取查询的时间类型
         timeType?: string;
         hide?: boolean;
         dealParam?(data): object;
     };
 
     export type DateItemType =
         | DateItemTypeI<CommonSelect, CommonSelectVOI.PropsI>
         | DateItemTypeI<BooleanSelect, BooleanSelectPropsI>
         | DateItemTypeI<DictSelect, DictSelectPropsI>
         | DateItemTypeI<EnumSelect, EnumSelectPropsI>
         | DateItemTypeI<any, any>
         | DateItemTypeI<typeof DatePicker, DatePickerProps>;
 }
 @Component
 export default class QueryForm extends Vue.Component<QueryFormVOI.PropsI> {
     @Prop({
         type: Array,
     })
     dataSource!: QueryFormVOI.DateItemType[];
 
     @Prop({
         type: Number,
     })
     labelWidth!: number;
 
     @Prop({
         type: Boolean,
         default: true,
     })
     showClear!: boolean;
 
     search() {
         this.$emit('search');
     }
 
     clear() {
         this.clearForm();
         this.$emit('clear');
     }
 
     getQueryObj<T>(): T {
         let o: any = {};
         for (let i = 0, l = this.dataSource.length; i < l; i++) {
             let item = this.dataSource[i];
             if (item.dealParam) {
                 o = { ...o, ...item.dealParam(item.props.value) };
                 continue;
             }
             switch (item.component) {
                 case DatePicker:
                     let timeType = item.timeType;
                     if ((item.props.type || 'daterange').indexOf('range') > -1) {
                         let startType!: GetMillisecondType, endType!: GetMillisecondType;
                         if (item.props.type === 'daterange') {
                             startType = 'start';
                             endType = 'end';
                         } else if (item.props.type === 'monthrange') {
                             startType = 'monthStart';
                             endType = 'monthEnd';
                         }
                         if ((item.props.value as IViewDate[])[0]) {
                             let field = item.realField ? item.realField[0] : item.field + 'Start';
                             o[field] = DateTimeUtil.getSecondFromIviewDate((item.props.value as IViewDate[])[0], startType);
                             if (timeType !== 'number') {
                                 o[field] =DateTimeUtil.formateDate(o[field]?o[field]*1000:null, timeType);
                             }
                         }
                         if ((item.props.value as IViewDate[])[1]) {
                             let field = item.realField ? item.realField[1] : item.field + 'End';
                             o[field] = DateTimeUtil.getSecondFromIviewDate((item.props.value as IViewDate[])[1], endType);
 
                             if (timeType !== 'number') {
                                 o[field] = DateTimeUtil.formateDate(o[field]?o[field]*1000:null, timeType);
                             }
                         }
                     } else {
                         o[item.field] =
                             timeType === 'number'
                                 ? DateTimeUtil.getSecondFromIviewDate(item.props.value as IViewDate)
                                 : DateTimeUtil.formateDate(item.props.value as IViewDate, timeType);
                     }
                     break;
                 default:
                     o[item.field] = item.props.value;
                     break;
             }
         }
         let map: any = {};
         Object.entries(o)
             .filter(i => !CommonUtil.isFieldEmpty(i[1]))
             .forEach(i => {
                 map[i[0]] = i[1];
             });
         return map;
     }
 
     clearForm(excludeFields: string[] = []) {
         for (let i = 0, l = this.dataSource.length; i < l; i++) {
             let item = this.dataSource[i];
             if (excludeFields.includes(item.field)) {
                 continue;
             }
             if (!CommonUtil.isUndefined(item.props.initValue)) {
                 item.props.value = item.props.initValue;
                 continue;
             }
             if (CommonUtil.isArray(item.props.value)) {
                 item.props.value = [];
             } else if (CommonUtil.isString(item.props.value)) {
                 item.props.value = '';
             } else if (CommonUtil.isNumber(item.props.value)) {
                 item.props.value = null;
             } else if (CommonUtil.isBoolean(item.props.value)) {
                 item.props.value = null;
             }
         }
     }
 
     getNode(h, i: QueryFormVOI.DateItemType) {
         let { value, ...props } = i.props;
         let attrs:any = {
             props: { value: i.props.value, ...props },
             on: { input: v => (i.props.value = v) },
         }
         if(i.component === Input) {
             attrs.on['on-keypress'] = (e)=> {
                 if(e.keyCode === 13) {
                     this.search()
                 }
             }
         }
         return h(i.component, attrs);
     }
     mounted() {
         this.dataSource.forEach(i => {
             if (!i.props.initValue) {
                 i.props.initValue = i.props.value;
             }
         });
     }
 
     render(h) {
         if (this.dataSource.length > 0) {
             return (
                 <i-form ref="searchForm" inline={true} class="wqms-search-wrapper" labelWidth={this.labelWidth || 80}>
                     {this.dataSource.map(i => {
                         return (
                             <form-item
                                 v-show={!i.hide}
                                 labelWidth={i.labelWidth}
                                 label={i.label}
                                 style={{ width: (i.width || 180) + 'px' }}
                             >
                                 {this.getNode(h, i)}
                             </form-item>
                         );
                     })}
                     <form-item label="" labelWidth={10} style="width: auto">
                         <Button class="wqms-btn-custom" type="primary" onClick={this.search}>
                             搜索
                         </Button>
                         <Button v-if={this.showClear} class="wqms-btn-custom wqms-ml15" type="info" onClick={this.clear}>
                             重置
                         </Button>
                     </form-item>
                 </i-form>
             );
         } else {
             return <div />;
         }
     }
 }
 